import {useNavigation, useRoute} from '@react-navigation/native';
import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {
  ActivityIndicator,
  Alert,
  KeyboardAvoidingView,
  Linking,
  Platform,
  Text,
  View,
  Image,
  Modal,
  Button,
  useWindowDimensions,
  FlatList,
  RefreshControl,
} from 'react-native';
import {useBiometricStore} from '../../store/BiometricStore';
import {
  getCredentialsPlain,
  saveCredentialsBiometric,
  saveCredentialsPlain,
} from '../../utils/biometricAuth';
import OrdersService from '../../services/OrdersService/OrdersService';
import {useBagStore} from '../../store/BagStore';
import DebtsService from '../../services/DebtsService/DebtsService';
import {useUserStore} from '../../store/UserStore';
import {useCatalogStore} from '../../store/CatalogStore';
import {useFilterStore} from '../../store/FilterStore';
import {useLimitStore} from '../../store/LimitStore';
import {ISegment} from '../../types/Filter';
import ModalFilter from './components/ModalFilter/ModalFilter';
import OrderScheduledModal from './components/OrderScheduledModal/OrderScheduledModal';
import PendingDebtModal from './components/PendingDebtModal/PendingDebtModal';
import SortModal from './components/SortModal/SortModal';
import {styles} from './styles';
import {HomeHeader} from './components/HomeHeader/HomeHeader';
import {masks} from '../../utils/mask';
import CompanyModal from '../Bag/components/CompanyModal/CompanyModal';
import Header from '../../components/Header/Header';
import {Images} from '../../constants/Images';
import {AppRoutes} from '../../navigation/Routes.types';
import ProductsService, {clientLimitsGet} from '../../services/ProductsService/ProductsService';
import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Input from '../../components/Input/Input';
import ProfileService from '../../services/ProfileService/ProfileService';
import {OneSignal} from 'react-native-onesignal';
import NPSModal from './components/NPSModal/NPSModal';
import AuthService from '../../services/AuthService/AuthService';
import {useAuthStore} from '../../store/AuthStore';
import {Colors} from '../../constants/Colors';
import {useIsDesktop} from '../../hooks/useIsDesktop';
import BagModal from './components/BagModal/BagModal';
import AxiosService from '../../services/AxiosService';
import ExtendedTermsService from '../../services/ExtendedTermsService/ExtendedTermsService';
import useExtendedTermsStore from '../../store/ExtendedTermsStore';
import {requestTrackingPermission} from 'react-native-tracking-transparency';
import {getAnalytics, logEvent} from '@react-native-firebase/analytics';
import ProductFavoriteService from '../../services/ProductFavoriteService/ProductFavoriteService';
import {useFavoritesStore} from '../../store/FavoritesStore';
import {useCommunicationModalStore} from '../../store/CommunicationModalStore';
import {useHomeSections, HomeSection} from '../../hooks/useHomeSections';
import FeaturedCarousel from './HomeSections/FeaturedCarousel';
import SuggestedCarousel from './HomeSections/SuggestedCarousel';
import CategoryCarousel from './HomeSections/CategoryCarousel';
import CatalogFullButton from './HomeSections/CatalogFullButton';
import { showSuccess, showInfo } from '../../utils/globalAlert';

const Home = () => {
  const [refreshing, setRefreshing] = useState<boolean>(false);
  const [filterModal, setFilterModal] = useState<boolean>(false);
  const [sort, setSort] = useState<boolean>(false);
  const {catalogData, setCatalogData} = useCatalogStore();
  const {user, setUser, catalogBlocked, catalogBlockedMessage, temporaryPasswordLogin} = useUserStore();
  const {biometricEnabled} = useBiometricStore();

  const {token} = useAuthStore();
  const activeCommunicationModal = useCommunicationModalStore(
    state => state.activeModal,
  );
  const {setLimit, setMinOrder, setBalance, setDigital, setLoadingLimit} = useLimitStore();

  const [loadingUpdatePassword, setLoadingUpdatePassword] =
    useState<boolean>(false);
  const [loadingUpdateContact, setLoadingUpdateContact] =
    useState<boolean>(false);
  const [segments, setSegments] = useState<ISegment[]>([]);
  const [companyModal, setCompanyModal] = useState<boolean>(false);

  const navigation = useNavigation();
  const route = useRoute();

  const [orderScheduledDate, setOrderScheduledDate] = useState<string | null>(
    null,
  );
  const [orderScheduled, setOrderScheduled] = useState<boolean>(false);
  const [hasFetchedCategories, setHasFetchedCategories] =
    useState<boolean>(false);
  const [favoriteProducts, setFavoriteProducts] = useState<any[]>([]);
  const [hasFetchedBrands, setHasFetchedBrands] = useState<boolean>(false);

  const [packagingFilter, setPackagingFilter] = useState<[]>([]);
  const [filterParams, setFilterParams] = useState({
    currentPage: 1,
    perPage: 30,
    brand: '',
    category: '',
    search: '',
    sort: '',
    packaging: '',
  });
  const [isNews, setIsNews] = useState<boolean>(false);
  const [newsData, setNewsData] = useState();
  const [suggestedRefreshKey, setSuggestedRefreshKey] = useState(1);
  const [forceSuggestedUpdate, setForceSuggestedUpdate] = useState(false);

  const [data, setData] = useState<INewPassword>({
    newPassword: '',
    confirmationNewPassword: '',
  });
  const [contact, setContact] = useState<IContact>({email: '', phone: ''});
  const [showPassModal, setShowPassModal] = useState<boolean>(false);
  const [showPendingDebtModal, setShowPendingDebtModal] =
    useState<boolean>(false);
  const [showContactModal, setShowContactModal] = useState<boolean>(false);
  const [npsModal, setNpsModal] = useState<boolean>(false);

  const {brand, selectedCategory, selectedBrand, setBrand, setCategory, setSelectedCategory} =
    useFilterStore();
  const {addProduct, updateProductQuantity} = useBagStore();
  const products = useBagStore(state => state.products);
  const setFavoriteCount = useFavoritesStore(state => state.setFavoriteCount);
  const setFavoriteSKUs = useFavoritesStore(state => state.setFavoriteSKUs);

  const analyticsInstance = getAnalytics();

  // Home sections (Catálogo Inteligente)
  const {sections, loading: sectionsLoading, refresh: refreshSections, lazyLoad} =
    useHomeSections();

  const isDesktop = useIsDesktop();
  const {width: windowWidth} = useWindowDimensions();
  const numColumns = useMemo(() => {
    if (Platform.OS !== 'web') return 2;
    if (windowWidth >= 1300) return 5;
    if (windowWidth >= 1000) return 4;
    if (windowWidth >= 750) return 3;
    return 2;
  }, [windowWidth]);

  const flatListRef = useRef<FlatList>(null);
  const [showButton, setShowButton] = useState(false);

  const handleScroll = (event: any) => {
    const {contentOffset, layoutMeasurement, contentSize} = event.nativeEvent;
    const deviceHeight = windowWidth;
    const isScrollable = contentSize.height > deviceHeight * 1.25;
    setShowButton(isScrollable && contentOffset.y > deviceHeight);
  };

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (showButton) {
      interval = setInterval(() => {
        setShowButton(false);
      }, 3000);
    }
    return () => clearInterval(interval);
  }, [showButton]);

  const scrollToTop = () => {
    flatListRef.current?.scrollToOffset({animated: true, offset: 0});
  };

  useEffect(() => {
    if (route?.params?.companyModal) {
      setCompanyModal(true);
      navigation.setParams({companyModal: undefined});
    }
  }, [route?.params?.companyModal]);

  useEffect(() => {
    if (route?.params?.npsVerify) {
      setNpsModal(true);
    }
  }, [route?.params?.npsVerify]);

  useEffect(() => {
    if (Platform.OS === 'ios') {
      requestTrackingPermission().catch(() => {});
    }
  }, []);

  useEffect(() => {
    if (user?.storeAccess) {
      setSelectedCategory(undefined);
      setCatalogData([]);
    }
  }, []);

  const getLimits = async () => {
    setLoadingLimit(true);
    try {
      const response = await clientLimitsGet(user?.clientCode);
      setLimit(response.Limitecredito ?? null);
      setMinOrder(response.Minimoorder ?? null);
      setBalance(response.Saldodisponivel ?? null);
      setDigital(response.Digital ?? null);
    } finally {
      setLoadingLimit(false);
    }
  };

  const getActiveFiltersCount = useCallback(() => {
    let count = 0;
    if (filterParams.brand) count++;
    if (filterParams.category) count++;
    if (filterParams.sort) count++;
    if (filterParams.packaging) count++;
    if (isNews) count++;
    return count;
  }, [filterParams, isNews]);

  const orderScheduledCheck = async (clientCode: string) => {
    await OrdersService.checkScheculedOrders(clientCode).then(res => {
      if (res && res.isOrderInProgress && res.nextDeliveryDate) {
        setOrderScheduledDate(res.nextDeliveryDate);
        setOrderScheduled(res.isOrderInProgress);
      }
    });
  };

  const checkDebtModal = async () => {
    try {
      const today = new Date().toDateString();
      const storageKey = `@debt_modal_shown_${user?.clientCode}`;
      const ultimaExibicao = await AsyncStorage.getItem(storageKey);
      if (ultimaExibicao !== today) {
        const response = await DebtsService.GetUpdatedDebts(user?.clientCode);
        const date = new Date();
        const showModal = response.some(debt => {
          if (debt.status === 'succeeded') return false;
          const expire = new Date(debt.ZFBDT);
          const diffDays = Math.floor(
            (date.getTime() - expire.getTime()) / (1000 * 60 * 60 * 24),
          );
          return diffDays > 15;
        });
        await AsyncStorage.setItem(storageKey, today);
        if (showModal) setShowPendingDebtModal(true);
      }
    } catch (error) {
      setShowPendingDebtModal(false);
    }
  };

  const {
    setData: setExtendedTerms,
    setLoading: setLoadingExternalTerms,
    setError,
  } = useExtendedTermsStore();

  const extendedTerms = async () => {
    setLoadingExternalTerms(true);
    try {
      const result = await ExtendedTermsService.ExtendedTerms(user?.clientCode);
      if (result?.data?.terms) setExtendedTerms(result.data.terms);
    } catch {
      setError('Erro ao buscar termos');
    } finally {
      setLoadingExternalTerms(false);
    }
  };

  useEffect(() => {
    if (!user?.clientCode || !user?.storeAccess) return;
    getFavoritesProducts();
    extendedTerms();
    orderScheduledCheck(user?.clientCode ?? '');
    checkDebtModal();
  }, [user?.clientCode, user?.storeAccess]);

  // Busca o limite só depois que o catálogo (seções da home) termina de
  // carregar pela primeira vez, pois é esse carregamento que materializa o
  // limite atualizado no backend.
  const initialLimitsFetchedRef = useRef(false);
  useEffect(() => {
    if (!user?.clientCode || !user?.storeAccess) return;
    if (sectionsLoading || initialLimitsFetchedRef.current) return;
    initialLimitsFetchedRef.current = true;
    getLimits();
  }, [user?.clientCode, user?.storeAccess, sectionsLoading]);

  useEffect(() => {
    if (temporaryPasswordLogin) return;
    const checkUpdates = async () => {
      const response = await AuthService.authCheckGet(token);
      if (response?.user) {
        if (!response.user.password_updated) setShowPassModal(true);
        if (!response.user.contact_updated) setShowContactModal(true);
      }
    };
    checkUpdates();
  }, [user?.password_updated, user?.contact_updated, temporaryPasswordLogin]);

  useEffect(() => {
    const verifyNotifications = async () => {
      const granted = await OneSignal.Notifications.canRequestPermission();
      return granted;
    };
    verifyNotifications().then(granted => {
      OneSignal.Notifications.requestPermission(granted).then(async accepted => {
        const playerId = await OneSignal.User.pushSubscription.getIdAsync();
        const clientCode = user?.current_client?.clientCode;
        if (accepted && playerId && clientCode) {
          await ProfileService.createOneSignalSubscription(playerId, clientCode);
        }
      });
    });
  }, []);

  const sendCart = async (cartProducts: any[]) => {
    const instance = AxiosService.createProductsAxiosInstance();
    const cartData = cartProducts.map(product => ({
      sku: product.sku,
      quantity: product.quantity,
    }));
    const clientCode = (user as any)?.clientCode || (user as any)?.current_client?.clientCode;
    const response = await instance.post(
      '/carts',
      {client_code: clientCode, data: cartData},
      {headers: {'Content-Type': 'application/json'}},
    );
    if (!response.data.data) {
      throw new Error('No data received from server');
    }
    return response.data.data;
  };

  const handleAddBag = (product: IProduct, quantity: number) => {
    const emptyBag = products.length === 0;
    const cartKey = (product as any).is_promotion
      ? `${product.sku}_promo`
      : product.sku;

    const {products: currentProducts} = useBagStore.getState();
    if (currentProducts.find(prod => (prod.cartKey ?? prod.sku) === cartKey)) {
      updateProductQuantity(cartKey, quantity);
      return;
    } else if (quantity > 0) {
      addProduct({...product, quantity, cartKey});
    } else {
      showInfo('Conecta Brasal', 'Informe a quantidade de itens.');
    }

    if (emptyBag) {
      sendCart(products).catch(error =>
        console.error('Erro ao enviar o carrinho:', error),
      );
    }
  };

  const openProduct = (product: IProduct) => {
    logEvent(analyticsInstance, 'product_view', {
      product_sku: product.sku,
      product_name: product.descricao,
      client_code: user?.clientCode,
    });
    navigation.navigate(AppRoutes.PRODUCT_DETAILS, {item: product});
  };

  const getFavoritesProducts = useCallback(async () => {
    try {
      const response = await ProductFavoriteService.getFavorites(
        user?.current_client?.clientCode || user?.clientCode,
      );
      const favData = response.data ?? [];
      setFavoriteProducts(favData);
      setFavoriteCount(Array.isArray(favData) ? favData.length : 0);
      setFavoriteSKUs(Array.isArray(favData) ? favData.map((f: any) => f.sku) : []);
    } catch (error) {
      setFavoriteProducts([]);
      setFavoriteCount(0);
      setFavoriteSKUs([]);
    }
  }, [setFavoriteCount, setFavoriteSKUs]);

  const getBrands = useCallback(async () => {
    try {
      const response = await ProductsService.GetBrands();
      setBrand(response);
      setHasFetchedBrands(true);
    } catch (error) {
      console.error('getBrands error:', error);
    }
  }, [setBrand]);

  const getSegments = useCallback(async () => {
    const priorityOrder = [
      'Combo', 'Refrigerantes', 'Água Crystal', 'Ades', 'Cervejas',
      'Destilados', 'Energéticos', 'Sucos', 'Chás', 'Drink',
      'Isotônicos', 'Suplementos',
    ];
    try {
      const response = await ProductsService.GetSegments(
        user?.current_client?.clientCode || user?.clientCode,
      );
      const sortedSegments = response.slice().sort((a, b) => {
        const indexA = priorityOrder.indexOf(a.name);
        const indexB = priorityOrder.indexOf(b.name);
        if (indexA === -1 && indexB === -1) return 0;
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      });
      setSegments(sortedSegments);
      setCategory(sortedSegments);
      setHasFetchedCategories(true);
    } catch (error) {
      setHasFetchedCategories(true);
    }
  }, [user?.clientCode, user?.current_client?.clientCode, setCategory]);

  useEffect(() => {
    if (!hasFetchedCategories && user?.clientCode) {
      getSegments();
    }
  }, [hasFetchedCategories, user?.clientCode, getSegments]);

  useEffect(() => {
    if (!hasFetchedBrands && selectedCategory) {
      getBrands();
    }
  }, [hasFetchedBrands, selectedCategory]);

  const UpdateContact = async () => {
    setLoadingUpdateContact(true);
    try {
      const response = await ProfileService.createNewContact(contact);
      setUser({...user, contact_updated: true});
      setShowContactModal(false);
      showSuccess('Sucesso', String(response?.details) || 'Contato alterado com sucesso');
    } catch (error) {
      Alert.alert('Erro', String(error?.response?.data?.details) || 'Erro ao alterar contato');
    } finally {
      setLoadingUpdateContact(false);
    }
  };

  const UpdatePassword = async () => {
    if (data.newPassword.length < 8) {
      Alert.alert('Validação dos campos', 'A nova senha deve ter pelo menos 8 caracteres');
      return;
    }
    if (data.newPassword !== data.confirmationNewPassword) {
      Alert.alert('Validação dos campos', 'As senhas não são iguais');
      return;
    }
    setLoadingUpdatePassword(true);
    try {
      const response = await ProfileService.createNewPassword(data);
      // Mantém as credenciais salvas coerentes com a nova senha.
      const loginUsername = (user as any)?.user || (user as any)?.email;
      if (loginUsername) {
        if (biometricEnabled) {
          await saveCredentialsBiometric(loginUsername, data.newPassword);
        } else {
          const existing = await getCredentialsPlain();
          if (existing) {
            await saveCredentialsPlain(loginUsername, data.newPassword);
          }
        }
      }
      setUser({...user, password_updated: true});
      setShowPassModal(false);
      showSuccess('Sucesso', String(response?.details) || 'Senha alterada com sucesso');
    } catch (error) {
      Alert.alert('Erro', String(error?.response?.data?.details) || 'Erro ao alterar senha');
    } finally {
      setLoadingUpdatePassword(false);
    }
  };

  const handleCloseModal = () => setCompanyModal(false);

  const handleRefresh = async () => {
    setRefreshing(true);
    lazyTriggered.current.clear();
    setLoadingLimit(true);
    try {
      await refreshSections(true);
      await getLimits();
    } catch (error) {
      console.error('Erro ao recarregar:', error);
      setLoadingLimit(false);
    } finally {
      setRefreshing(false);
    }
  };
  const handleSeeAllFeatured = () => {
    navigation.navigate(AppRoutes.FEATURED_PRODUCTS as never);
  };

  const handleSeeAllSuggested = () => {
    navigation.navigate(AppRoutes.CATALOG_BROWSE as never, {
      filter: {source: 'suggested'},
    } as never);
  };

  const handleSeeAllCategory = (carouselId: number, categoryNames: string[], displayName: string) => {
    navigation.navigate(AppRoutes.CATALOG_BROWSE as never, {
      filter: {carouselId, categoryNames, title: displayName, lockedCategory: true},
    } as never);
  };

  const handleCatalogFull = () => {
    navigation.navigate(AppRoutes.CATALOG_BROWSE as never);
  };

  // Virtualized section list + viewport-based lazy loading.
  // lazyLoad is read through a ref so the viewability callback keeps a stable
  // identity (RN requires onViewableItemsChanged not to change between renders).
  const lazyLoadRef = useRef(lazyLoad);
  useEffect(() => {
    lazyLoadRef.current = lazyLoad;
  }, [lazyLoad]);
  const lazyTriggered = useRef<Set<number>>(new Set());

  const viewabilityConfig = useRef({
    itemVisiblePercentThreshold: 20,
  }).current;

  const onViewableItemsChanged = useRef(
    ({viewableItems}: {viewableItems: Array<{item: HomeSection}>}) => {
      viewableItems.forEach(({item}) => {
        if (
          item?.kind === 'carousel' &&
          item.load === 'lazy' &&
          item.products === null &&
          !lazyTriggered.current.has(item.id)
        ) {
          lazyTriggered.current.add(item.id);
          lazyLoadRef.current(item.id);
        }
      });
    },
  ).current;

  const sectionKeyExtractor = useCallback((item: HomeSection, index: number) => {
    if (item.kind === 'carousel') return `carousel-${item.id}`;
    return `${item.kind}-${index}`;
  }, []);

  const renderSection = useCallback(
    ({item}: {item: HomeSection}) => {
      if (item.kind === 'featured') {
        return (
          <FeaturedCarousel
            products={item.products}
            loading={sectionsLoading}
            onAddBag={handleAddBag}
            onOpenProduct={openProduct}
            onSeeAll={handleSeeAllFeatured}
            clientCode={user?.current_client?.clientCode}
          />
        );
      }
      if (item.kind === 'suggested') {
        return (
          <SuggestedCarousel
            products={item.products}
            loading={sectionsLoading}
            onAddBag={handleAddBag}
            onOpenProduct={openProduct}
            onSeeAll={handleSeeAllSuggested}
            clientCode={
              (user as any)?.clientCode ||
              (user as any)?.current_client?.clientCode
            }
          />
        );
      }
      if (item.kind === 'carousel') {
        return (
          <CategoryCarousel
            id={item.id}
            displayName={item.displayName}
            categoryNames={item.categoryNames}
            load={item.load}
            products={item.products}
            onAddBag={handleAddBag}
            onOpenProduct={openProduct}
            onSeeAll={handleSeeAllCategory}
            clientCode={user?.current_client?.clientCode}
          />
        );
      }
      return null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sectionsLoading, user],
  );

  const memoizedHeader = useMemo(
    () => (
      <HomeHeader
        user={user}
        filterParams={filterParams}
        setFilterParams={setFilterParams}
        segments={segments}
        setCatalogData={setCatalogData}
        setNewsData={setNewsData}
        isNews={isNews}
        setIsNews={setIsNews}
        setFilterModal={setFilterModal}
        getActiveFiltersCount={getActiveFiltersCount}
        handleAddBag={(item: any, quantity: number) => handleAddBag(item, quantity)}
        openProduct={(item: any) => openProduct(item)}
        refreshKey={suggestedRefreshKey}
        forceSuggestedUpdate={forceSuggestedUpdate}
        setForceSuggestedUpdate={setForceSuggestedUpdate}
        hasFetchedCategories={hasFetchedCategories}
        favoriteProductsCount={favoriteProducts?.length ?? 0}
        onLayoutHeader={() => {}}
        onLayoutAboveMarcas={() => {}}
        onCategorySelected={(categoryName: string) => {
          navigation.navigate(AppRoutes.CATALOG_BROWSE as never, {
            filter: {
              categoryNames: [categoryName],
              title: categoryName,
              lockedCategory: true,
            },
          } as never);
        }}
        onFilterChangeShouldScroll={() => {}}
      />
    ),
    [
      user,
      filterParams,
      segments,
      isNews,
      getActiveFiltersCount,
      selectedCategory,
      suggestedRefreshKey,
      forceSuggestedUpdate,
      favoriteProducts,
      hasFetchedCategories,
    ],
  );

  if (!user) return <></>;

  return (
    <>
      <Modal visible={showPassModal && !activeCommunicationModal} animationType="slide">
        <KeyboardAvoidingView
          behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
          style={[{flex: 1}]}>
          <View style={styles.modalContainer}>
            <View style={styles.modalContent}>
              <Text style={styles.modalTitle}>Senha temporária</Text>
              <Text style={styles.modalMessage}>
                Identificamos que você está utilizando uma senha temporária, por
                favor, altere sua senha para continuar.
              </Text>
              <Input
                title="Senha nova"
                placeholder="Senha nova..."
                hasSecurity
                mt={10}
                onChangeText={text => setData({...data, newPassword: text})}
              />
              <Input
                title="Confirmar nova senha"
                placeholder="Confirmar nova senha..."
                hasSecurity
                mt={10}
                onChangeText={text =>
                  setData({...data, confirmationNewPassword: text})
                }
              />
              <View style={styles.containerButton}>
                {loadingUpdatePassword ? (
                  <ActivityIndicator color={Colors.RedPallete.red} size="large" />
                ) : (
                  <ButtonComponent title="Alterar senha" onPress={UpdatePassword} width="100%" />
                )}
              </View>
            </View>
          </View>
        </KeyboardAvoidingView>
      </Modal>

      <Modal
        visible={showContactModal && !showPassModal && !activeCommunicationModal}
        animationType="slide">
        <KeyboardAvoidingView
          behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
          style={[{flex: 1}]}>
          <View style={styles.modalContainer}>
            <View style={styles.modalContent}>
              <Text style={styles.modalTitle}>Informações de contato</Text>
              <Text style={styles.modalMessage}>
                Atualize suas informações de contato!
              </Text>
              <Input
                title="E-mail"
                mt={10}
                placeholder="e-mail@nomedaloja.com"
                autoCapitalize="none"
                keyboardType="email-address"
                onChangeText={text => setContact({...contact, email: text})}
              />
              <Input
                title="Telefone"
                mt={10}
                placeholder="(61)99999-9999"
                maxLength={15}
                value={contact.phone}
                onChangeText={text => {
                  const onlyNumbers = text.replace(/\D/g, '');
                  if (onlyNumbers.length <= 11) {
                    setContact({...contact, phone: masks.maskPhone(onlyNumbers)});
                  }
                }}
              />
              <View style={styles.containerButton}>
                {loadingUpdateContact ? (
                  <ActivityIndicator color={Colors.RedPallete.red} size="large" />
                ) : (
                  <ButtonComponent title="Atualizar" onPress={UpdateContact} width="100%" />
                )}
              </View>
            </View>
          </View>
        </KeyboardAvoidingView>
      </Modal>

      <KeyboardAvoidingView
        style={{flex: 1, marginBottom: isDesktop ? 0 : Platform.OS === 'web' ? 52 : 85}}
        behavior={Platform.OS === 'ios' ? 'padding' : undefined}>
        {catalogBlocked ? (
          <View style={{flex: 1}}>
            <Header setSearchOnParams={() => {}} refreshing={refreshing} />
            <View style={{flex: 1, justifyContent: 'center', alignItems: 'center', paddingHorizontal: 30}}>
              <Image source={Images.ProfileSimbol} style={styles.simbol} />
              <Text style={{textAlign: 'center', fontSize: 16, marginTop: 20, color: '#333', lineHeight: 24}}>
                {(catalogBlockedMessage || 'O catálogo está temporariamente indisponível.')
                  .split(/(\+?55\s?\(?\d{2}\)?\s?\d{4,5}[-\s]?\d{4})/)
                  .map((part, i) =>
                    /\+?55\s?\(?\d{2}\)?\s?\d{4,5}[-\s]?\d{4}/.test(part) ? (
                      <Text
                        key={i}
                        style={{color: Colors.RedPallete.red, textDecorationLine: 'underline', fontWeight: 'bold'}}
                        onPress={() => Linking.openURL(`tel:${part.replace(/\D/g, '')}`)}>
                        {part}
                      </Text>
                    ) : (
                      part
                    ),
                  )}
              </Text>
            </View>
          </View>
        ) : user?.storeAccess ? (
          <View style={[styles.container, isDesktop && {maxWidth: 1200, alignSelf: 'center', width: '100%', paddingHorizontal: 24}]}>
            <Header setSearchOnParams={() => {}} refreshing={refreshing} />
            <FlatList
              ref={flatListRef}
              data={sections}
              keyExtractor={sectionKeyExtractor}
              renderItem={renderSection}
              showsVerticalScrollIndicator={Platform.OS === 'web'}
              contentContainerStyle={{paddingBottom: 100}}
              ListHeaderComponent={memoizedHeader}
              ListFooterComponent={
                <CatalogFullButton onPress={handleCatalogFull} />
              }
              onViewableItemsChanged={onViewableItemsChanged}
              viewabilityConfig={viewabilityConfig}
              initialNumToRender={4}
              maxToRenderPerBatch={4}
              windowSize={7}
              removeClippedSubviews
              onScroll={handleScroll}
              scrollEventThrottle={16}
              refreshControl={
                <RefreshControl
                  refreshing={refreshing}
                  onRefresh={handleRefresh}
                  colors={[Colors.RedPallete.red]}
                  tintColor={Colors.RedPallete.red}
                />
              }
            />

            <ModalFilter
              visible={filterModal}
              onRequestClose={() => setFilterModal(false)}
              currentSort={filterParams.sort}
              currentCategory={filterParams.category}
              currentBrands={filterParams.brand ? [filterParams.brand] : []}
              currentNews={isNews}
              currentCombo={filterParams.category === 'Combo'}
              returnFilter={filter => {
                setCatalogData([]);
                setNewsData([]);
                if (filter.news) {
                  setIsNews(true);
                  setSelectedCategory(undefined);
                  setFilterParams({...filterParams, category: undefined, sort: undefined, packaging: undefined, currentPage: 1});
                } else if (filter.combo) {
                  setIsNews(false);
                  setSelectedCategory(undefined);
                  setFilterParams({...filterParams, category: 'Combo', currentPage: 1});
                } else {
                  setIsNews(false);
                  setSelectedCategory(filter.category);
                  setFilterParams({...filterParams, category: filter.category, sort: filter.sort, packaging: filter.packaging, currentPage: 1});
                }
              }}
              cleanFilter={() => {
                setSelectedCategory(undefined);
                setFilterParams({...filterParams, category: undefined, brand: '', sort: '', packaging: '', currentPage: 1});
                setCatalogData([]);
                setNewsData([]);
              }}
              hasBrand
              hasCategory
              hasNews
              hasOrder
              hasSize
              hasCombo
              hasPackaging
              packagingList={packagingFilter}
              onPressNews={() => setIsNews(true)}
              onPressCombo={() =>
                setFilterParams({...filterParams, category: 'Combo', currentPage: 1})
              }
            />
            <NPSModal
              visible={npsModal}
              onClose={() => setNpsModal(false)}
              onSurvey={() => {
                navigation.navigate(AppRoutes.NPS);
                setNpsModal(false);
              }}
            />
            <SortModal
              visible={sort}
              onRequestClose={() => setFilterModal(false)}
              onCloseSort={() => setSort(false)}
              currentSort={filterParams.sort}
              returnOrder={typeOrder => {
                setCatalogData([]);
                setNewsData([]);
                setFilterParams({...filterParams, sort: typeOrder, currentPage: 1});
              }}
            />
            <PendingDebtModal
              visible={showPendingDebtModal && !showPassModal && !showContactModal && !activeCommunicationModal}
              date={orderScheduledDate}
              onPress={() => setShowPendingDebtModal(false)}
              onRequestClose={() => setShowPendingDebtModal(false)}
            />
            <OrderScheduledModal
              visible={orderScheduled && !showPassModal && !showContactModal && !showPendingDebtModal && !activeCommunicationModal}
              date={orderScheduledDate}
              onPress={() => setOrderScheduled(false)}
              onRequestClose={() => setOrderScheduled(false)}
            />
            <BagModal />
          </View>
        ) : (
          <>
            <View style={styles.container2}>
              <Text style={{textAlign: 'center', fontSize: 18, marginTop: 20}}>
                <Header />
              </Text>
            </View>
            <View style={styles.container3}>
              <Image source={Images.ProfileSimbol} style={styles.simbol} />
            </View>
          </>
        )}
        <CompanyModal
          onPress={() => null}
          onRequestClose={handleCloseModal}
          visible={companyModal}
        />
      </KeyboardAvoidingView>
    </>
  );
};

export default Home;
